"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CancelController = /** @class */ (function () {
    function CancelController() {
        var _this = this;
        this.resolve = function () { return void 0; };
        this.promise = new Promise(function (resolve) {
            _this.resolve = resolve;
        });
    }
    CancelController.prototype.cancel = function () {
        this.resolve();
    };
    CancelController.prototype.onCancel = function (fn) {
        this.promise.then(fn);
    };
    return CancelController;
}());
exports.default = CancelController;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uploadcare/upload-client/lib/tools/CancelController.js
// module id = 645
// module chunks = 70